module.exports = __webpack_public_path__ + "media/images/home/ic_view-89fb0983635562acde6466ed81ab7a80.svg";